export enum ImageFormat {
  Svg  = 'svg',
  Eps  = 'eps',
  Jpg  = 'jpg',
  Jpeg  = 'jpeg',
  Pdf  = 'pdf',
  Base64  = 'base64',
  Icns  = 'icns',
  Ico  = 'ico',

  Json = 'json',
  Gif  = 'gif',
  Mp4  = 'mp4',
  WMp4  = 'wmp4',
  Delottie  = 'delottie',


  Png  = 'png',
  Blend = 'blend',
  Fbx = 'fbx',
  AEP='aep',
  Zip='zip'
}
